import React from "react";
import { NavLink } from "react-router-dom";
import { ONLINE_ADMISSION_URL } from "../../../data/externalLinks";

const linkClass =
  " font-serif w-fit sm:w-full xs:w-full font-semibold text-xl text-[#0863AA] py-8 px-16 hover:bg-white hover:text-[#0863AA] ";
const activeClass =
  " font-sans w-fit font-semibold text-xl sm:w-full xs:w-full px-16 text-[#5ab848] hover:bg-[#ffffff] bg-[#ffffff] hover:text-[#0863AA] py-8";

const AdmissionNav = () => {
  const menus = [
    { id: 1, menu: "Admission", link: "admisionnotice" },
    { id: 2, menu: "Apply Online", link: ONLINE_ADMISSION_URL, external: true },
    { id: 3, menu: "Contact", link: "admissioncontacts" },
    { id: 4, menu: "Required Documents", link: "checklists" },
    { id: 5, menu: "Admission Test Result", link: "result" },
  ];

  return (
    <div className="flex flex-row xs:flex-col sm:flex-col justify-center w-full bg-[#e7e9ea]">
      {menus.map((m) =>
        m.external ? (
          <a
            key={m.id}
            href={m.link}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
          >
            {m.menu}
          </a>
        ) : (
          <NavLink
            key={m.id}
            to={`/admision/${m.link}`}
            className={({ isActive }) => (isActive ? activeClass : linkClass)}
          >
            {m.menu}
          </NavLink>
        )
      )}
    </div>
  );
};

export default AdmissionNav;
